import React from "react"
import { Col, Container, Row } from "react-bootstrap"
import logo from "../../images/logo.png"

const HeaderComponent = () => {
  return (
    <Container fluid className="bg-light shadow-sm top-header p-3">
      <Row className="align-items-center">
        <Col xs={12} md={6} className="d-flex align-items-center">
          <div>
            <img src={logo} width="100" alt="Logo" className="mr-3" />

            <h6 className="text-muted mb-0">Test Intelligence Solution</h6>
          </div>
        </Col>
        {/* <Col xs={12} md={6} className="text-md-right mt-3 pr-3 text-muted text-center">
          <h4>Documentation</h4>
        </Col> */}
      </Row>
    </Container>
  )
}

export default HeaderComponent
